<template lang="pug">
  div
    p.text-center Etiquetas de la conversación
    .text-right
      b-button.mb-3(size="sm", variant="link", @click="labels_modal = true")
        .d-flex.align-items-center.justify-content-center
          sliders-icon.mr-2.icon-sm
          span Editar etiquetas
    b-input-group.mb-3(size="sm")
      b-form-input(placeholder="Buscar etiqueta...", v-model="search", type="search")
      b-input-group-append
        b-input-group-text
          search-icon.text-secondary.icon-sm
    b-card.no-shadow.bg-light
      .text-center.text-help(v-if="!parsedLabels.length") No hay etiquetas para mostrar
      b-form-group(v-else)
        b-form-checkbox-group(v-model="conversation_labels", stacked, :options="parsedLabels", @change="changed")
    b-modal(scrollable, size="lg", ok-title="Cerrar", v-model="labels_modal", okOnly, ok-variant="secondary", title="Administrar etiquetas", @hide="resetModal")
      b-card.mb-0(no-body)
        template(slot="header")
          b-row.align-items-center(no-gutters)
            b-col.d-flex.align-items-center
              span.mb-0.mr-3 Etiquetas
              b-spinner(variant="primary", small, v-if="loading")
            b-col(cols="auto")
              b-button(variant="primary", size="sm", block, @click="expandRow({item: label_data})") Crear etiqueta
        b-table.card-table.table-nowrap.mb-0(:items="state_labels", :fields="fields", responsive, show-empty, ref="labels_table", hover, @row-clicked="expandRow({item: $event})")
          template(v-slot:empty)
            p.mb-0.text-help No hay etiquetas para mostrar
          template(v-slot:cell(name)="{ item }")
            span.text-success.mr-2(v-if="item.new") ●
            span {{ item.name }}
          template(v-slot:cell(color)="data")
            b-img.img(rounded="circle", :blank="true", :blankColor="data.item.color", width="20", height="20")
          template(v-slot:cell(actions)="data")
            edit-3-icon.icon-md.mr-4.hover-primary.pointer(v-b-tooltip.hover="'Editar'", @click="expandRow(data)", :class="{'blue' : data.detailsShowing}")
            trash-2-icon.icon-md.hover-danger.pointer(v-b-tooltip.hover="'Eliminar'", @click="deleteLabel(data.item)")
    b-modal(ok-title="Guardar", v-model="edit_label_modal", ok-variant="primary", cancel-title="Cancelar", title="Editar etiqueta", @ok="label_data.label_id ? updateLabel() : createLabel()")
      b-container(fluid)
        label Nombre:
        b-form-input.mb-2(v-model="label_data.name" placeholder="Nombre", trim, @input="saved = false", :state="label_data.name ? null : (label_data.validated ? false : null)")
        label Descripción:
        b-form-input.mb-2(v-model="label_data.description" placeholder="Descripción", trim, @input="saved = false")
        label Color:
        color-picker.mb-2(v-model="label_data.color", @input="saved = false")
        b-card.bg-light.text-center.text-sm.mb-0.mt-4
          alert-triangle-icon.icon-sm.mr-2
          span Eliminar etiqueta no se puede deshacer.
          p.mb-0.mt-2
            b-link.text-danger(@click="deleteLabel(label_data)") Eliminar etiqueta
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import { Chrome } from 'vue-color'
import debounce from 'lodash.debounce'
import { EventBus } from '../helpers/eventBus'

const labelController = createNamespacedHelpers('label')

export default {
  data () {
    return {
      filters_open: false,
      conversation_labels: [],
      labels_modal: false,
      edit_label_modal: false,
      fields: [
        {
          key: 'name',
          label: 'Nombre'
        },
        {
          key: 'description',
          label: 'Descripción'
        },
        {
          key: 'color',
          label: 'Color'
        },
        // {
        //   key: 'actions',
        //   label: 'Acciones'
        // }
      ],
      label_data: {
        name: '',
        description: '',
        color: '',
        label_id: '',
        validated: false
      },
      saved: true,
      search: '',
      loading: false
    }
  },
  computed: {
    ...labelController.mapState({
      state_labels: state => state.labels
    }),
    parsedLabels () {
      return this.state_labels.map(l => {
        return {
          text: l.name,
          value: {
            title: l.name,
            label_id: l.label_id
          }
        }
      }).filter(l => {
        if (!this.search) return true
        return (l.value.title || '').toLowerCase().indexOf(this.search) > -1
      })
    }
  },
  methods: {
    ...mapActions([
      'conversation/get',
      'conversation/update',
      'label/all',
      'label/create',
      'label/update',
      'label/destroy'
    ]),
    getConversation() {
      const self = this

      this['conversation/get']({
        conversation_id: self.$route.params.conversation_id,
        callback: res => {
          if (res.error) return self.$message.error(res.error)

          for (let label of res.resource.label_ids.filter(l => l !== undefined)) {
            const { name: title, label_id } = self.state_labels.find(l => l.label_id == label)

            if (title && label_id) self.conversation_labels.push({ title, label_id })
          }
        }
      })
    },
    updateConversation: debounce(function() {
      const self = this
      // this.showLoadingScreen()

      this['conversation/update']({
        conversation_id: self.$route.params.conversation_id,
        label_ids: self.conversation_labels.map(l => l.label_id),
        callback: res => {
          this.hideLoadingScreen()

          if (res.error) return self.$message.error(res.error)

          EventBus.$emit('getCurrentConversation')
          self.$message.success('Admins actualizados')
        }
      })
    }, 700),
    changed () {
      const self = this

      self.updateConversation()
    },
    getLabels() {
      let self = this

      this['label/all']({
        account_id: self.$route.params.account_id,
        callback: res => {
          if (res.error) return self.$message.error(res.error)
        }
      })
    },
    createLabel () {
      var self = this

      if (!this.label_data.name) {
        this.label_data.validated = true
        return
      }

      if(this.label_data.color.hex) this.label_data.color = this.label_data.color.hex
      this.loading = true
      this['label/create']({
        account_id: self.$route.params.account_id,
        ...self.label_data,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            //self.getLabels()
          }
        }
      })
    },
    updateLabel () {
      if (!this.label_data.name) {
        this.label_data.validated = true
        return
      }

      if(this.label_data.color.hex) this.label_data.color = this.label_data.color.hex
      //this.label_data.color = this.label_data.color.hex || this.label_data.color

      var self = this
      this['label/update']({
        account_id: self.$route.params.account_id,
        ...self.label_data,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            //self.getLabels()
            self.saved = true
            self.edit_label_modal = false
            self.clearObject(self.label_data)
          }
        }
      })
    },
    async deleteLabel (label) {
      var self = this
      try {
        let response = await this.$bvModal.msgBoxConfirm(`¿Deseas eliminar esta etiqueta? No se puede deshacer.`, {
          title: 'Eliminar etiqueta',
          okVariant: 'danger',
          okTitle: 'Eliminar',
          cancelTitle: 'Cancelar'
        })
        if(response){
          this['label/destroy']({
            ...label,
            callback: res => {
              if (res.error) {
                self.$message.error(res.error)
              } else {
                //self.getLabels()
                self.edit_label_modal = false
              }
            }
          })
        }
      } catch (e) {
        console.error(e.message);
      }
    },
    resetModal () {
      for (let item of this.$refs.labels_table.items) {
        if(item._showDetails)
          item._showDetails = false
      }
    },
    expandRow (data) {
      this.clearObject(this.label_data)
      this.label_data = Object.assign(this.label_data, data.item)
      this.$nextTick(() => {
        this.edit_label_modal = true
      })
    },
  },
  mounted () {
    this.$nextTick(() => {
      this.getConversation()
    })
  },
  components: {
    'color-picker' : Chrome
  }
}
</script>

<style lang="scss" scoped>
  .scrollable-container-sm {
    max-height: 200px;
    overflow: hidden;
    overflow-y: auto;
    word-break: break-all;
  }

  .collapse-icon {
    transition: 0.3s;
  }

  .upsidedown {
    transform: rotate(-180deg);
  }

  .blue {
    color: var(--blue)
  }
</style>

<style>
  .vc-chrome {
    box-shadow: none !important;
    border: 1px solid #ccc;
  }
</style>
